import { ReactNode } from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { capitalize } from "@mui/material/utils";

interface SettingsSectionProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  divider?: boolean;
  subtitleError?: boolean;
}

const SettingsSection = ({
  title,
  subtitle,
  children,
  divider = true,
  subtitleError = false,
}: SettingsSectionProps): ReactNode => {
  return (
    <Stack
      direction={"column"}
      display={"flex"}
      alignItems={"flex-start"}
      gap={2}
    >
      <Box sx={{ pt: 3 }}>
        <Typography variant="h6" textTransform={"capitalize"}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color={subtitleError ? 'error' : 'initial'}>{capitalize(subtitle)}</Typography>
        )}
      </Box>
      {children}
      {divider ? (
        <Divider orientation="horizontal" sx={{ width: "100%", pt: 3 }} />
      ) : (
        <Box sx={{ width: "100%", pt: 3 }} />
      )}
    </Stack>
  );
};

export default SettingsSection;
